import script from "./FileUploaderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploaderModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__